module.exports = __webpack_public_path__ + "static/images/share-props.a6d8444.png";